import React, { lazy, Suspense } from 'react';
import { Switch } from 'react-router-dom'
import { AppLayout } from '../../layouts';
import { EbPageLoader } from '../Common';


const InvoiceList = lazy(() => import('.').then((module) => ({ default: module.InvoiceList })));

const InvoiceRouter = (props) => {
    const AppRoute = props.AppRoute;
    return (
        <Switch>
            <Suspense fallback={<EbPageLoader />}>
                <AppRoute exact path="/invoices" layout={AppLayout} component={InvoiceList} pathkey="invoices" />
            </Suspense>
        </Switch>
    )
}

export { InvoiceRouter };